import React from 'react';

const PaginationData = ({
    currentPage = 1,
    handlePage,
    lastPage = 1,
    totalItems = lastPage,
    itemsPerPage = 10
}) => {
    const generatePages = () => {
        const pages = [];
        const showCount = 5;

        if (lastPage <= showCount + 4) {
            for (let i = 1; i <= lastPage; i++) {
                pages.push(i);
            }
        } else if (currentPage <= showCount) {
            for (let i = 1; i <= showCount; i++) {
                pages.push(i);
            }
            pages.push('...');
            for (let i = lastPage - 1; i <= lastPage; i++) {
                pages.push(i);
            }
        } else if (currentPage >= lastPage - 3) {
            for (let i = 1; i <= 2; i++) {
                pages.push(i);
            }
            pages.push('...');
            for (let i = lastPage - 4; i <= lastPage; i++) {
                pages.push(i);
            }
        } else {
            for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                pages.push(i);
            }
            pages.push('...');
            for (let i = lastPage - 1; i <= lastPage; i++) {
                pages.push(i);
            }
        }

        return pages;
    };

    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <div className="flex flex-col items-center gap-2 mt-4">
            <div className="text-sm text-gray-600">
                {totalItems > 0
                    ? `Showing ${startItem}–${endItem} of ${totalItems}`
                    : 'No data available'}
            </div>

            <div className="flex items-center gap-2">
                <button
                    onClick={() => currentPage > 1 && handlePage(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 border rounded disabled:text-gray-400 disabled:border-gray-300"
                >
                    &lt;
                </button>

                {generatePages().map((page, idx) => (
                    <button
                        key={idx}
                        onClick={() => page !== '...' && handlePage(page)}
                        disabled={page === '...'}
                        className={`px-3 py-1 rounded border ${
                            page === currentPage
                                ? 'bg-blue-500 text-white border-blue-500'
                                : page === '...'
                                ? 'text-gray-500 border-gray-300 cursor-default'
                                : 'hover:bg-blue-100 border-gray-300'
                        }`}
                    >
                        {page}
                    </button>
                ))}

                <button
                    onClick={() => currentPage < lastPage && handlePage(currentPage + 1)}
                    disabled={currentPage === lastPage}
                    className="px-3 py-1 border rounded disabled:text-gray-400 disabled:border-gray-300"
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};

export default PaginationData;
